<script>
import { mapState } from "vuex";

import { validateAndSubmit } from "../../../mixins/validateAndSubmit";
import { validationClass } from "../../../mixins/validationClass";

export default {
  data() {
    return {
      form: {
        name: null,
        email: null,
        message: null,
      },
      disableOnSubmit: false,
    };
  },

  props: ["url", "defaultMessage"],

  mixins: [validateAndSubmit, validationClass],

  computed: {},

  created() {},

  mounted() {
    this.form.message = this.defaultMessage;
  },

  watch: {},

  methods: {
      validateAndSubmitAndClean(formName) {
            this.disableOnSubmit = true;

            this.$validator.validateAll(formName).then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    axios
                        .post(this.url, this.form)
                        .then(response => {
                            this.form.name = null;
                            this.form.email = null;
                        })
                        .catch(error => {
                            console.log(error);
                        })
                        .finally(() => {
                            // Do something afterwards
                        });
                }
            });

            this.disableOnSubmit = false;
        }
  },

  components: {},
};
</script>
